import { PAGE_SIZES, type Page } from "@/hooks/usePager";

interface Props {
  pager: Page<unknown>;
  className?: string;
}

const NAV =
  "press w-10 h-10 sm:w-8 sm:h-8 flex items-center justify-center rounded-md border border-background-300 bg-background-50 text-foreground-600 hover:bg-background-100 cursor-pointer disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:bg-background-50";

/** Barre de pagination : « 1–10 sur 120 », lignes par page, page précédente / suivante. Masquée si tout tient sur une page. */
export default function Pagination({ pager, className = "" }: Props) {
  const { page, pages, total, size, setPage, setSize } = pager;
  if (total <= PAGE_SIZES[0]) return null;
  const first = (page - 1) * size + 1;
  const last = Math.min(page * size, total);

  return (
    <div className={`flex flex-wrap items-center justify-between gap-3 px-4 py-3 text-sm text-foreground-600 ${className}`}>
      <span>
        {first}–{last} sur {total}
      </span>
      <div className="flex items-center gap-3">
        <label className="hidden items-center gap-1.5 sm:flex">
          <span>Lignes par page</span>
          <select
            value={size}
            onChange={(e) => setSize(Number(e.target.value))}
            className="rounded-md border border-background-300 bg-background-50 px-2 py-1 text-sm cursor-pointer focus:border-primary-500 focus:outline-none"
          >
            {PAGE_SIZES.map((s) => (
              <option key={s} value={s}>
                {s}
              </option>
            ))}
          </select>
        </label>
        <div className="flex items-center gap-1.5">
          <button type="button" className={`${NAV} hidden sm:flex`} onClick={() => setPage(1)} disabled={page <= 1} aria-label="Première page">
            <i className="ri-skip-left-line"></i>
          </button>
          <button type="button" className={NAV} onClick={() => setPage(page - 1)} disabled={page <= 1} aria-label="Page précédente">
            <i className="ri-arrow-left-s-line"></i>
          </button>
          <span className="min-w-[64px] text-center tabular-nums">
            Page {page} / {pages}
          </span>
          <button type="button" className={NAV} onClick={() => setPage(page + 1)} disabled={page >= pages} aria-label="Page suivante">
            <i className="ri-arrow-right-s-line"></i>
          </button>
          <button type="button" className={`${NAV} hidden sm:flex`} onClick={() => setPage(pages)} disabled={page >= pages} aria-label="Dernière page">
            <i className="ri-skip-right-line"></i>
          </button>
        </div>
      </div>
    </div>
  );
}
